import './App.css'
import {useEffect} from 'react';
import {ConfigProvider, Spin} from "antd";
import ContentContainer from "./components/ContentContainter/ContentContainer.jsx";
import {Outlet, useNavigate} from "react-router-dom";
import {$authStatus, setAuthStatusEv} from "./models/authModel/index.js";
import {useUnit} from 'effector-react';
import { cookies } from './api/axiosinstance.js';
import ChatPreset from "./pages/Chat/ChatPreset.jsx";


function App() {

    const auth = useUnit($authStatus)
    const setAuth = useUnit(setAuthStatusEv);
    const navigate = useNavigate()

    console.log('auth', auth)


    useEffect(() => {
        if (!auth ) {
            const token = cookies.get('access_token');
            if (!token) {
                navigate('/login');
            } else {
                setAuth(true);
            }
        }
    }, [auth, location]);

  return (
      <ConfigProvider
          // theme={theme}
      >
          {/*<Spin>*/}
              <ContentContainer>
                  <ChatPreset />
                  <Outlet/>
              </ContentContainer>
          {/*</Spin>*/}

      </ConfigProvider>
  )
}

export default App
